import type { CardDefinition, RunState } from "../types/index.js";
import { canSpendEnergy } from "../cards/spendEnergy.js";

export function canPlayCard(
  run: RunState,
  def: CardDefinition,
): boolean {
  if (run.pendingChoice) return false;
  if (def.type === "worker") return false;
  if (!run.activeCase) return false;
  return canSpendEnergy(run, run.activeCase);
}
